import React from 'react'
import {
    Switch,
    Route,
    Redirect
} from 'react-router-dom'
import {Card, Button, Link} from '@shopify/polaris'
import Customers from './pages/Customers'
import Reports from './pages/Reports'


function Routes(){
    return (
        <Switch>
            <Route path="/customers">
                <Customers />
            </Route>
            <Route path="/reports">
                <Reports />
            </Route>
            <Route path="/">
                <Redirect to="/customers" />
            </Route>
        </Switch>
    )
}

export default Routes